export default __webpack_public_path__ + "static/no-image-b0540e7c349442b8b32bc89d7f9d66ad.jpg";